// Error boundary (Implementation Plan v02 §5.1): any screen that throws falls
// back to a calm screen that still offers the always-available safety controls
// (Help now / Hide are wired in I-1a). It never shows a stack trace or diary
// content, and never analyses anything.

import { Component, type ErrorInfo, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  readonly children: ReactNode
  readonly fallback: ReactNode
}

interface ErrorBoundaryState {
  readonly hasError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Local only: nothing leaves the device (no crash reporting, red line).
    // A content-free activity event is recorded by `activity/` from I-1a.
    if (import.meta.env.DEV) {
      console.error('[shell] render error', error, info.componentStack)
    }
  }

  override render(): ReactNode {
    return this.state.hasError ? this.props.fallback : this.props.children
  }
}
